// extracted by mini-css-extract-plugin
export default {"container":"gHhiQ","consent-container":"jNwT6","consent-text":"Mt0sK"};